import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/publicdomain.png'
import _imports_1 from '../assets/cc-zero.png'
import _imports_2 from '../assets/by-sa.png'
import _imports_3 from '../assets/by-nc.png'
import _imports_4 from '../assets/by-nc-nd.png'
import _imports_5 from '../assets/InCopyright.png'
import _imports_6 from '../assets/InCopyright-NonCommercial.png'
import _imports_7 from '../assets/InCopyright-rightsholder.png'
import _imports_8 from '../assets/Copyright-Undetermined.svg'
import _imports_9 from '../assets/NoKnownCopyright.svg'


const _hoisted_1 = { class: "w-full h-min flex flex-wrap place-content-center px-12 lg:px-36 sm:px-16 md:px-24 bg-background-light" }
const _hoisted_2 = { class: "font-bold text-3xl my-7 lg:my-12" }
const _hoisted_3 = { class: "bg-background-medium flex flex-wrap overflow-y-auto" }
const _hoisted_4 = { class: "px-12 space-y-6 mt-12 lg:px-36 sm:px-16 md:px-24" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "font-bold text-xl" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "font-bold text-xl" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "font-bold text-xl" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = { class: "font-bold text-xl" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "font-bold text-xl pb-4" }
const _hoisted_18 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-16" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-full w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-ful",
    src: _imports_0
  })
], -1)
const _hoisted_20 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "font-bold text-xl pb-4" }
const _hoisted_24 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w-full w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_1
  })
], -1)
const _hoisted_26 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_27 = { class: "font-bold" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-full w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_2
  })
], -1)
const _hoisted_31 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_3
  })
], -1)
const _hoisted_36 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_37 = { class: "font-bold" }
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-16" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_4
  })
], -1)
const _hoisted_41 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_42 = { class: "font-bold" }
const _hoisted_43 = { class: "text-sm" }
const _hoisted_44 = { class: "font-bold text-xl pb-4" }
const _hoisted_45 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_5
  })
], -1)
const _hoisted_47 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_48 = { class: "font-bold" }
const _hoisted_49 = { class: "text-sm" }
const _hoisted_50 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_6
  })
], -1)
const _hoisted_52 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_53 = { class: "font-bold" }
const _hoisted_54 = { class: "text-sm" }
const _hoisted_55 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_7
  })
], -1)
const _hoisted_57 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_58 = { class: "font-bold" }
const _hoisted_59 = { class: "text-sm" }
const _hoisted_60 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_8
  })
], -1)
const _hoisted_62 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_63 = { class: "font-bold" }
const _hoisted_64 = { class: "text-sm" }
const _hoisted_65 = { class: "flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-10 pb-16" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/5 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_9
  })
], -1)
const _hoisted_67 = { class: "w-4/5 flex flex-col space-y-3" }
const _hoisted_68 = { class: "font-bold" }
const _hoisted_69 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    large: true,
    scroll: true,
    "modal-state": _ctx.CCModalState.state,
    onHideModal: _ctx.closeCCModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('copyright.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('copyright.whatAreCC')), 1),
            _createElementVNode("p", {
              innerHTML: _ctx.t('copyright.whatAreCCText'),
              class: "text-sm"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.t('copyright.whatAreRS')), 1),
            _createElementVNode("p", {
              innerHTML: _ctx.t('copyright.whatAreRSText'),
              class: "text-sm"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t('copyright.whatRSUsed')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t('copyright.whatRSUsedText')), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t('copyright.whatIsReuse')), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t('copyright.whatIsReuseText')), 1)
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('copyright.publicDomainTitle')), 1),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.t('copyright.PDM')), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.t('copyright.PDMText')), 1)
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.t('copyright.creativeCommonsTitle')), 1),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.t('copyright.CC0')), 1),
                _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.t('copyright.CC0Text')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.t('copyright.CC-BY-SA')), 1),
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.t('copyright.CC-BY-SAText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.t('copyright.CC-BY-NC')), 1),
                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.t('copyright.CC-BY-NCText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.t('copyright.CC-BY-NC-ND')), 1),
                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.t('copyright.CC-BY-NC-NDText')), 1)
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.t('copyright.rightsStatementsTitle')), 1),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.t('copyright.InCopyright')), 1),
                _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.t('copyright.InCopyrightText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.t('copyright.InCopyrightNonCommercial')), 1),
                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.t('copyright.InCopyrightNonCommercialText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.t('copyright.InCopyrightUnknown')), 1),
                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.t('copyright.InCopyrightUnknownText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.t('copyright.InCopyrightUndetermined')), 1),
                _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.t('copyright.InCopyrightUndeterminedText')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.t('copyright.NoKnownCopyright')), 1),
                _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.t('copyright.NoKnownCopyrightText')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "onHideModal"]))
}